import React from 'react';
import { useTranslation } from 'react-i18next';

import { appReactMemo } from 'hocs';

import { RowCellContainer } from '../../styled';
import { Text } from '../RowCell/styled';

interface TBinaryCellData<T> {
  center?: boolean;
  className?: string;
  dataKey?: keyof T;
  item: T;
  rowIndex: number;
}

const BinaryCell = <T,>({
  center,
  className,
  dataKey,
  item,
  rowIndex,
}: TBinaryCellData<T>): React.ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'common' });

  const cellData =
    dataKey &&
    dataKey
      .toString()
      .split('.')
      .reduce<null | string | T>(
        (accumulator, currentValue) => accumulator?.[currentValue as never] || null,
        item,
      );

  return (
    <RowCellContainer
      $center={center}
      $index={rowIndex}
      className={className}
      data-testid={`${dataKey as string}Cell`}
    >
      <Text>{cellData ? t('yes') : t('no')}</Text>
    </RowCellContainer>
  );
};

export default appReactMemo(BinaryCell);
